export function invokeImmediately<ReturnType>(functionToInvoke: () => ReturnType): ReturnType {
  return functionToInvoke();
}

export const iif = invokeImmediately;

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isValidJSON(str) {
  try {
    return !isNumeric(str) && !!JSON.parse(str)
  } catch (e) {
    return false;
  }
}

export function convertJSONtoCSV(data, headerOffset: number = 0, rowOffset: number = 0) {
  const header = ",".repeat(headerOffset) + Object.keys(data[0]).join(',') + '\n';
  const rows = data.map(obj => ",".repeat(rowOffset) + Object.values(obj).join(',') + '\n');
  return header + rows.join('');
}
